import { render, staticRenderFns } from "./SendVirtualEmail.vue?vue&type=template&id=1f9d783c"
import script from "./SendVirtualEmail.vue?vue&type=script&lang=js"
export * from "./SendVirtualEmail.vue?vue&type=script&lang=js"
import style0 from "./SendVirtualEmail.vue?vue&type=style&index=0&id=1f9d783c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports